<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <vue-element-loading is-full-screen :active="loading" spinner="bar-fade-scale" color="#152d51" />
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">เปลี่ยนแปลงที่อยู่</h3>
    </div>
    <div class="w-100 session-with-nav " style="height: calc(100vh - 67px);overflow: auto;">
      <div class="mb-2 flex-all-center">
        <div>
          <v-img class="my-0 radius-circle" style="width:170px;height:auto" src="@/assets/logo_long.png"></v-img>
        </div>
      </div>
      <div class="px-5">
        <div class="text-blue">กรุณากรอกที่อยู่ใหม่</div>
        <FormUpdateAddress @submit="submit" :option="showOp" :loading="loading" />
      </div>
    </div>
    <ShowSuccessDialog v-if="showDone" v-model="showDone">กรอกข้อมูลสำเร็จ</ShowSuccessDialog>
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
import VueElementLoading from "vue-element-loading";
import FormUpdateAddress from "@/components/formUpdateAddress.vue";
import ShowSuccessDialog from "@/components/SuccessDialog.vue";
export default {
  components: { FormUpdateAddress, VueElementLoading, ShowSuccessDialog },
  data() {
    return {
      loading: false,
      updateData: {},
      addressData: [],
      showDone: false,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    profile() {
      return this.$store.state.profile;
    },
    lineUserId() {
      return this.$store.state.profile.userId;
    },
    paraUserId() {
      return this.$store.state.query.userid;
    },
    paraUserId2() {
      return this.$route.query.userid;
    },
    assigngroupid() {
      return this.$store.state.query.assigngroupid ? this.$store.state.query.assigngroupid : 0;
    },
    menu() {
      return this.$store.state.menu;
    },
    showOp() {
      if (this.$store.state.addressType && this.$store.state.addressType != "ที่อยู่จัดส่งเอกสาร") {
        return true;
      } else {
        return false;
      }
    },
    authData() {
      return this.$store.state.formatAuthorizeData;
    },
    mainAddress() {
      return this.$store.state.selectAddress;
      // if (this.addressData && this.addressData.length) {
      //   let data = this.addressData.filter((x) => {
      //     return x.isMaillingAddress === "Yes";
      //   });
      //   return data && data.length ? data[0] : [];
      // } else {
      //   return null;
      // }
    },
  },
  watch: {},
  mounted() {
    // this.setup();
  },
  methods: {
    async submit(data) {
      let vm = this;
      if (this.authData && this.authData.idcard && this.authData.dob && this.authData.nextcard) {
        let id = vm.paraUserId || vm.lineUserId || vm.paraUserId2;
        let channel = id.length > 25 ? "line" : "facebook";
        if (channel == "line" && !id.match(`__${config.pageid}`)) {
          id = `${id}__${config.pageid}`;
        }
        let body = {
          pageid: config.pageid,
          userid: id,
          subject: "ต้องการเปลี่ยนแปลงที่อยู่",
          details: "ไม่ผูกบัญชี",
          channel,
          status: "pending",
          assigngroupid: this.assigngroupid,
          json_variable: {
            type: "address",
            text1: this.menu || "",
            text2: "",
            userdata: {
              dob: this.authData.dob,
              nextCard: this.authData.nextcard,
              IDCard: this.authData.idcard,
              faceImage: this.authData.faceImage,
              idcardImage: this.authData.idcardImage,
            },
            updateData: {
              IDCard: this.authData.idcard,
              BirthDay: this.authData.dob,
              NextCard: this.authData.nextcard,
              addressCode: this.mainAddress.addressCode,
              ...data,
            },
          },
        };
        if (!data.isMaillingAddress) {
          body.json_variable.updateData.isMaillingAddress = this.mainAddress.isMaillingAddress;
        } else if (data.isMaillingAddress) {
          body.json_variable.text2 = "ต้องการแก้ไขที่อยู่จัดส่งเอกสารด้วย";
        }
        this.loading = true;
        let createStatus = await api.createTicket(body);
        this.loading = false;
        if (createStatus) {
          this.showDone = true;
          await this.$store.dispatch("sendMessage", "กรุณารอเจ้าหน้าที่ทำการตรวจสอบข้อมูล");
        } else {
          this.$swal.fire({
            type: "error",
            text: "อัพเดทข้อมูลไม่สำเร็จ",
          });
        }
      } else {
        this.$swal.fire({
          type: "error",
          text: "ข้อมูลไม่ครบถ้วน",
        });
      }
    },
  },
};
</script>

<style></style>
